import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "text", "help"];
var __jsx = React.createElement;
import React from "react";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import BackToOriginal from "../BackToOriginal";
import Styles from "./Styles.module.scss";
function Head(_ref) {
  var title = _ref.title,
    text = _ref.text,
    help = _ref.help,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ELSGrid, _extends({
    container: true,
    alignItems: "center",
    className: Styles.head
  }, props), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    className: Styles.head__title,
    "data-cy": "newQS-page-header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "sr-only"
  }, "Engineering Village - Quick Search"), /*#__PURE__*/React.createElement("h2", null, title, " ", /*#__PURE__*/React.createElement("br", null), text)), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }));
}
Head.defaultProps = {};
export default Head;